/**
 * Detects a new admin deploy while a tab is still open.
 *
 * Vite emits /version.json at build time; the same id is baked into the
 * bundle as __APP_VERSION__. On focus/visibility we re-fetch version.json
 * (never from cache) and reload if it diverges — so users don't need a
 * hard-refresh after deploy.
 */
declare const __APP_VERSION__: string;

const POLL_MS = 60_000;

export function watchAppVersion(): void {
  if (import.meta.env.DEV) return;
  if (typeof __APP_VERSION__ === 'undefined') return;

  let checking = false;
  let lastCheck = 0;

  const check = async () => {
    const now = Date.now();
    if (checking || now - lastCheck < 5_000) return;
    checking = true;
    lastCheck = now;
    try {
      const res = await fetch(`/version.json?_=${now}`, { cache: 'no-store' });
      if (!res.ok) return;
      const data = (await res.json()) as { version?: string };
      if (data.version && data.version !== __APP_VERSION__) {
        location.reload();
      }
    } catch {
      /* offline / flaky network — ignore */
    } finally {
      checking = false;
    }
  };

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') void check();
  });
  window.addEventListener('focus', () => void check());
  window.setInterval(() => {
    if (document.visibilityState === 'visible') void check();
  }, POLL_MS);
}
